// React
import React from 'react'
// Components
import BackButton from '../Nav/BackButton'
import SigninOutButton from '../Nav/SigninOutButton'
import Tabs from './Tabs'

export default (props) => (
	<div>
		<BackButton {...props} />
		<SigninOutButton {...props} />
		<div className='capps-height-20' />
		<div className='capps-container'>
			<Tabs {...props} />
		</div>
		<div className='capps-height-20' />
	</div>
)



// WEBPACK FOOTER //
// ./src/Components/Home/Tab.js